import { render } from "./PenyusunanDokumenPemilihan.vue?vue&type=template&id=3b61b91b&scoped=true"
import script from "./PenyusunanDokumenPemilihan.vue?vue&type=script&lang=js"
export * from "./PenyusunanDokumenPemilihan.vue?vue&type=script&lang=js"

import "./PenyusunanDokumenPemilihan.vue?vue&type=style&index=0&id=3b61b91b&scoped=true&lang=css"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b61b91b"]])

export default __exports__